import { render, staticRenderFns } from "./AudioView.vue?vue&type=template&id=50f2704c&scoped=true"
import script from "./AudioView.vue?vue&type=script&lang=js"
export * from "./AudioView.vue?vue&type=script&lang=js"
import style0 from "./AudioView.vue?vue&type=style&index=0&id=50f2704c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2704c",
  null
  
)

export default component.exports